import { itiHttpService, itiMessageService, itiTokenService } from '@/iti-core-vue';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchingOfferDemand from '@/components/matching_offer_demand/matching_offer_demand.vue';
import offerDemandModule from '@/store/modules/offer-demand.module';
import { CollaborativeAreaMember } from '@/shared/dtos/collaborative-area-member';
import {Guid} from "guid-typescript";


@Component({
    components: { 
        MatchingOfferDemand,   
    }
  })

export default class OfferDemandMatching extends Vue {

  @Prop() public id !: number;  
  @Prop() public type !: string;  

  public get offerDemand() {
    if (offerDemandModule.offerDemand.id == this.id) {
      return offerDemandModule.offerDemand;
    }
  }

  public get matching() {
    return offerDemandModule.matching;
  }

  public get collaborativeArea() {   
    return collaborativeAreaModule.selectedCollaborativeArea;
  }

  public mounted() {
      offerDemandModule.getOfferDemandById([this.id,this.type]);
  }

  public prepareCollaborativeArea() {
    collaborativeAreaModule.fetchId()
    .then( () => {
      if(this.offerDemand != null) {
        collaborativeAreaModule.newCollaborativeArea();
        this.collaborativeArea.name = this.offerDemand.description;
        this.collaborativeArea.description = "Área" + this.offerDemand.code;
        this.collaborativeArea.active = true;        
        this.collaborativeArea.type = 2;        
      }      
    });    
  }

}